import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import { toast } from "react-toastify";
import {
  API_CALL_CENTRE_CREATE,
  API_COUNTRY_CODES_LIST,
  API_TIMEZONES_LIST,
  API_PARENT_CALL_CENTER_LICENCE,
  API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST,
  API_SIGNUP_EMAIL_SEND_CODE,
  API_SIGNUP_EMAIL_VERIFY_CODE,
  API_ACL_SETTING_LIST,
} from "../../../service/url";
import CountryCodeDirectionPicker from "../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionPicker";
import LicenceAllocationPanel from "../../../components/partials/dashboard/company/LicenceAllocationPanel";
import { postApiCall, getApiCall, fetchAndSetFlashMessage } from "../../../service/httpCall";
import { useNavigate } from "react-router-dom";
import {
  ROUTES,
  USER_ROLES,
  MODULE_ACL,
  FLASH_MESSAGE_ACTION_OBJECT,
} from "../../../utilities/constant";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { Storage, getUserCreateAccessRoleLabel } from "../../../utilities/setting";
import { validateEmail } from "../../../utilities/helpers";
import {
  filterDefaultCallCentreUserRoles,
  isCompanyUserCreatingCallCentre,
} from "../../../utilities/defaultCallCentreUserRoles";
import DefaultCallCentreUserForm from "../../../components/partials/dashboard/call-centre/DefaultCallCentreUserForm";
import {
  FiUser,
  FiGlobe,
  FiClock,
  FiAlignLeft,
  FiFlag,
  FiUsers,
  FiActivity,
  FiShare2,
  FiPhone,
  FiSmartphone,
} from "react-icons/fi";
import { FaHeadset } from "react-icons/fa";
import "../../../assets/custom/css/custom.css";

function IconField({ icon: Icon, children, hasTrailing, trailingIcon: TrailingIcon, textarea }) {
  return (
    <div
      className={`ccf-input-with-icon${textarea ? " ccf-input-with-icon--textarea" : ""}${
        hasTrailing ? " ccf-input-with-icon--trailing" : ""
      }${TrailingIcon ? " ccf-input-with-icon--icon-right" : ""}`}
    >
      {!TrailingIcon && Icon && (
        <span className="ccf-input-with-icon__icon">
          <Icon size={18} />
        </span>
      )}
      {children}
      {TrailingIcon && (
        <span className="ccf-input-with-icon__icon ccf-input-with-icon__icon--right">
          <TrailingIcon size={18} />
        </span>
      )}
    </div>
  );
}

const CallCentreCreate = () => {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();

   const [name, setName] = useState('');
   const [domain, setDomain] = useState('');
   const [description, setDescription] = useState('');
   const [buttonDisable, setButtonDisable] = useState(false);
   const [countryCodeList, setCountryCodeList] = useState([]);
   const [countryCode, setCountryCode] = useState('');
   const [timezonesList, setTimezonesList] = useState([]);
   const [timezone, setTimezone] = useState('');
   const [filteredTimezones, setFilteredTimezones] = useState([]);
   const [parentLicence, setParentLicence] = useState(null);
   const [agent, setAgent] = useState(0);
   const [liveAgent, setLiveAgent] = useState(0);
   const [channel, setChannel] = useState(0);
   const [errors, setErrors] = useState({});
   const [loginUserRole, setLoginUserRole] = useState(null);
   const [nameError, setNameError] = useState('');
   const [domainError, setDomainError] = useState('');
   const [notes, setNotes] = useState([]);
   const [cps, setCps] = useState(0);
   const [mobile, setMobile] = useState(0);
   const [countryCodeDirections, setCountryCodeDirections] = useState([]);
   const [selectedCountryCodeDirections, setSelectedCountryCodeDirections] = useState([]);

  const [defaultUserName, setDefaultUserName] = useState("");
  const [defaultUsername, setDefaultUsername] = useState("");
  const [defaultUserEmail, setDefaultUserEmail] = useState("");
  const [defaultUserPassword, setDefaultUserPassword] = useState("");
  const [defaultUserConfirmPassword, setDefaultUserConfirmPassword] = useState("");
  const [showDefaultPassword, setShowDefaultPassword] = useState(false);
  const [signupEmailOtp, setSignupEmailOtp] = useState("");
  const [signupEmailToken, setSignupEmailToken] = useState("");
  const [emailVerifiedForCreate, setEmailVerifiedForCreate] = useState(false);
  const [signupEmailBusy, setSignupEmailBusy] = useState(false);
  const [defaultUserRoleSelection, setDefaultUserRoleSelection] = useState("");
  const [defaultUserRoleOptions, setDefaultUserRoleOptions] = useState([]);
  const [defaultUserFlowType, setDefaultUserFlowType] = useState("");
  const [defaultUserAclList, setDefaultUserAclList] = useState([]);
  const [defaultUserAcl, setDefaultUserAcl] = useState("");

  useEffect(() => {
    const user = (() => {
      try {
        return JSON.parse(Storage.getItem("user"));
      } catch {
        return null;
      }
    })();
    const creatorRole = user?.role || null;
    if (creatorRole) {
      setLoginUserRole(creatorRole);
    }

    getUserCreateAccessRoleLabel()
      .then((resp) => {
        const filtered = filterDefaultCallCentreUserRoles(resp || [], creatorRole);
        if (filtered.length) {
          setDefaultUserRoleOptions(filtered);
          setDefaultUserRoleSelection(filtered[0].value);
        } else {
          setDefaultUserRoleOptions([]);
          setDefaultUserRoleSelection("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (!defaultUserRoleSelection) {
      setDefaultUserAclList([]);
      setDefaultUserAcl("");
      return;
    }
    getApiCall(
      `${API_ACL_SETTING_LIST}?target_role=${encodeURIComponent(defaultUserRoleSelection)}`,
      {}
    )
      .then((list) => {
        setDefaultUserAclList(list || []);
        const defaultAcl = (list || []).find(
          (acl) => acl.default_for_role === defaultUserRoleSelection
        );
        if (defaultAcl) {
          setDefaultUserAcl(String(defaultAcl.id));
        } else {
          setDefaultUserAcl("");
        }
      })
      .catch((err) => console.error(err));
  }, [defaultUserRoleSelection]);

  useEffect(() => {
    getApiCall(API_PARENT_CALL_CENTER_LICENCE)
      .then((resp) => {
        setParentLicence(resp?.parentLicence);
      })
      .catch((error) => {
        toast.warning(typeof error === "string" ? error : JSON.stringify(error));
      });

    fetchAndSetFlashMessage(
      (msg) =>
        msg.module_name === MODULE_ACL.CALL_CENTRE &&
        msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD &&
        msg.type === "Note",
      setNotes
    );
  }, []);

  const validateInput = (value, key) => {
    if (value === "" || value == null) {
      return 0;
    }
    const digitsOnly = String(value).replace(/\D/g, "");
    if (digitsOnly === "") {
      return 0;
    }
    const num = parseInt(digitsOnly, 10);
    let newErrors = { ...errors };

    if (Number.isNaN(num)) return 0;
    if (num < 0) {
      newErrors[key] = "Value cannot be negative";
      setErrors(newErrors);
      return 0;
    }

  const licenceKeyMap = {
   //  role_ccadmin: "role_ccadmin",
    agent: "role_ccagent",
    live_agent: "live_agent",
    channel: "channel",
     cps: "cps",
    mobile: "mobile",
    reseller: "reseller",
    company: "company",
   
  };

    const licenceKey = licenceKeyMap[key];
    const availableValue = parentLicence?.available_licence?.[licenceKey];

    if (availableValue === 0 && num > 0) {
      newErrors[key] = `Value cannot be more than 0`;
      setErrors(newErrors);
      return num;
    }

    newErrors[key] = "";

    const nextAgent = key === "agent" ? num : agent;
    const nextLiveAgent = key === "live_agent" ? num : liveAgent;

    if (nextAgent < nextLiveAgent) {
      newErrors.agent = "Total Agent cannot be less than Live Agent";
      newErrors.live_agent = "Live Agent cannot be more than Total Agent";
    } else {
      newErrors.agent = "";
      newErrors.live_agent = "";
    }

    if (availableValue != null && availableValue > 0 && num > availableValue) {
      newErrors[key] = `Value cannot be more than ${availableValue}`;
    }

    if (key === "live_agent" && num > nextAgent) {
      newErrors.live_agent = `Live Agent cannot be more than Total Agent (${nextAgent})`;
    }

    setErrors(newErrors);
    return num;
  };

  const getLicenceMax = (key) => {
    const avail = parentLicence?.available_licence;
    if (avail == null) return undefined;
    const map = {
      agent: avail.role_ccagent,
      live_agent: avail.live_agent,
      channel: avail.channel,
      cps: avail.cps,
      mobile: avail.mobile,
    };
    return map[key];
  };

  const stepLicence = (key, current, setter, delta) => {
    const next = Math.max(0, (parseInt(String(current), 10) || 0) + delta);
    setter(validateInput(String(next), key));
  };

  const canIncrementLicence = (key, current) => {
    const max = getLicenceMax(key);
    if (max === undefined || max === null) return true;
    return (parseInt(String(current), 10) || 0) < max;
  };

  useEffect(() => {
    getApiCall(API_COUNTRY_CODES_LIST, {})
      .then(onCountryCodeListSuccess)
      .catch(onError);

    getApiCall(API_TIMEZONES_LIST, {})
      .then(onTimezonesListSuccess)
      .catch(onError);

    getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, {})
      .then((data) => setCountryCodeDirections(Array.isArray(data) ? data : []))
      .catch(() => setCountryCodeDirections([]));
  }, []);

  useEffect(() => {
    checkAuth();
  }, []);

  function onCountryCodeListSuccess(resp) {
    setCountryCodeList(resp);
  }

  function onTimezonesListSuccess(resp) {
    setTimezonesList(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate);
    } else {
      console.log(err);
    }
  }

  const validateName = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setNameError("Name is required");
      return false;
    }
    if (trimmedValue.length < 3) {
      setNameError("Name must be at least 3 characters long");
      return false;
    }
    if (trimmedValue.length > 500) {
      setNameError("Name must not exceed 500 characters");
      return false;
    }
    const nameRegex = /^[a-zA-Z0-9_]+$/;
    if (!nameRegex.test(trimmedValue)) {
      setNameError(
        "Name can only contain letters, numbers, and underscores (_). No special characters allowed."
      );
      return false;
    }
    setNameError("");
    return true;
  };

  const validateDomain = (value) => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      setDomainError("Domain is required");
      return false;
    }

    if (trimmedValue.length > 500) {
      setDomainError("Domain must not exceed 500 characters");
      return false;
    }

    const urlRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

    if (!urlRegex.test(trimmedValue)) {
      setDomainError(
        "Please enter a valid URL (e.g., https://example.com or http://example.com)"
      );
      return false;
    }

    setDomainError("");
    return true;
  };

  function validateForm() {
    let valid = true;
    let errorMessage = "";

    const nameValid = validateName(name);
    const domainValid = validateDomain(domain);

    if (!nameValid) {
      valid = false;
      errorMessage = nameError || "Name validation failed";
    }
    if (!domainValid) {
      valid = false;
      errorMessage = errorMessage
        ? `${errorMessage}; ${domainError || "Domain validation failed"}`
        : domainError || "Domain validation failed";
    }
    if (!description.trim()) {
      valid = false;
      errorMessage = errorMessage ? `${errorMessage}; Description required` : "Description required";
    }
    if (!countryCode.trim()) {
      valid = false;
      errorMessage = errorMessage
        ? `${errorMessage}; Country Code required`
        : "Country Code required";
    }
    if (!timezone.trim()) {
      valid = false;
      errorMessage = errorMessage
        ? `${errorMessage}; Timezone required`
        : "Timezone required";
    }

    if (!valid && errorMessage) {
      toast.warning(errorMessage);
    }

    return valid;
  }

  function validateDefaultUserFields() {
    let valid = true;
    if (!defaultUserName.trim()) {
      valid = false;
      toast.error("Default user name is required");
    }
    if (!defaultUsername.trim() || defaultUsername.trim().length < 3) {
      valid = false;
      toast.error("Default user username is required (min 3 characters)");
    }
    if (!defaultUserEmail.trim() || validateEmail(defaultUserEmail)) {
      valid = false;
      toast.error("Valid default user email is required");
    }
    if (!defaultUserPassword.trim() || defaultUserPassword.length < 8) {
      valid = false;
      toast.error("Default user password is required (min 8 characters)");
    }
    if (defaultUserPassword !== defaultUserConfirmPassword) {
      valid = false;
      toast.error("Default user passwords do not match");
    }
    if (!defaultUserRoleSelection) {
      valid = false;
      toast.error("Select a role for the default user");
    }
    if (
      defaultUserRoleSelection === USER_ROLES.CALL_CENTRE_ADMIN &&
      (defaultUserFlowType === "" || defaultUserFlowType === null)
    ) {
      valid = false;
      toast.error("Flow type is required for Call Centre Admin");
    }
    if (!defaultUserAcl) {
      valid = false;
      toast.error("Default user ACL is required");
    }
    if (!emailVerifiedForCreate || !signupEmailToken) {
      valid = false;
      toast.error(
        "Verify the default user email: use Send code, enter the OTP, then click Verify OTP."
      );
    }
    const needsAgentLicence =
      defaultUserRoleSelection === USER_ROLES.CALL_CENTRE_AGENT;
    const needsTeamLeadLicence =
      defaultUserRoleSelection === USER_ROLES.CALL_CENTRE_TEAM_LEAD;
    if (needsAgentLicence && (parseInt(String(agent), 10) || 0) < 1) {
      valid = false;
      toast.error("Allocate at least 1 Total Agent licence for a default Agent user");
    }
    if (needsTeamLeadLicence && (parseInt(String(agent), 10) || 0) < 1) {
      valid = false;
      toast.error("Allocate at least 1 agent licence for a default Team Lead user");
    }
    return valid;
  }

  const handleDefaultUserEmailChange = (e) => {
    setDefaultUserEmail(e.target.value);
    setSignupEmailToken("");
    setSignupEmailOtp("");
    setEmailVerifiedForCreate(false);
  };

  const sendDefaultUserSignupEmailCode = async () => {
    if (!defaultUserEmail.trim() || validateEmail(defaultUserEmail)) {
      toast.error("Enter a valid email before sending a code.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      await postApiCall(API_SIGNUP_EMAIL_SEND_CODE, { email: defaultUserEmail.trim() });
      setSignupEmailToken("");
      setEmailVerifiedForCreate(false);
      toast.success("Verification code sent. Check the inbox for this email.");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Could not send verification code");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  const verifyDefaultUserSignupEmailOtp = async () => {
    if (!defaultUserEmail.trim() || validateEmail(defaultUserEmail)) {
      toast.error("Enter a valid email.");
      return;
    }
    if (!signupEmailOtp || signupEmailOtp.length !== 6) {
      toast.error("Enter the 6-digit code from the email.");
      return;
    }
    setSignupEmailBusy(true);
    try {
      const data = await postApiCall(API_SIGNUP_EMAIL_VERIFY_CODE, {
        email: defaultUserEmail.trim(),
        otp: signupEmailOtp.trim(),
      });
      if (data?.signupEmailToken) {
        setSignupEmailToken(data.signupEmailToken);
        setEmailVerifiedForCreate(true);
        toast.success("Email verified.");
      } else {
        toast.error("Unexpected response from server");
      }
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Verification failed");
      setEmailVerifiedForCreate(false);
      setSignupEmailToken("");
    } finally {
      setSignupEmailBusy(false);
    }
  };

  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    if (!validateDefaultUserFields()) {
      setButtonDisable(false);
      return;
    }

    const params = {
      name,
      domain,
      description,
      countryCode,
      timezone,
      licence: {
        role_ccagent: agent,
        live_agent: liveAgent,
        channel: channel,
        cps: cps,
        mobile: mobile,
        reseller: 0,
        company: 0,
      },
    };

    if (selectedCountryCodeDirections?.length > 0) {
      params.country_code_directions = selectedCountryCodeDirections.map(Number);
    }

    params.default_user = {
      name: defaultUserName.trim(),
      username: defaultUsername.trim(),
      email: defaultUserEmail.trim(),
      password: defaultUserPassword,
      signup_email_token: signupEmailToken,
      role: defaultUserRoleSelection,
      acl_settings: defaultUserAcl,
      ...(defaultUserRoleSelection === USER_ROLES.CALL_CENTRE_ADMIN && {
        flow_type: Number(defaultUserFlowType),
      }),
    };

    postApiCall(API_CALL_CENTRE_CREATE, params)
      .then(onCreateCreateSuccess)
      .catch(onCreateCreateError);
  }

  function onCreateCreateSuccess() {
    toast.success("Call centre and default user created successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.CALL_CENTRES.LIST}`);
    }, 1500);
  }

  function onCreateCreateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate);
    } else {
      setButtonDisable(false);
      toast.warning(typeof err === "string" ? err : JSON.stringify(err));
    }
  }

  const handleCountryChange = (e) => {
    const selectedCountryId = e.target.value;
    setCountryCode(selectedCountryId);
    setTimezone("");

    const selectedCountry = countryCodeList.find((c) => c.id === selectedCountryId);
    if (selectedCountry) {
      const filtered = timezonesList.filter((tz) =>
        tz.value.toLowerCase().includes(selectedCountry.name.toLowerCase())
      );
      setFilteredTimezones(filtered);
    } else {
      setFilteredTimezones([]);
    }
  };

  const licenceNote =
    notes.find((n) => Number(n.priority) === 1)?.message ??
    "One Call Centers Licence is automatically used for the newly created Callcentre.";

  const licenceFooterNote =
    loginUserRole !== USER_ROLES.SUPERADMIN
      ? notes.find((n) => Number(n.priority) === 2)?.message ??
        "This licence detail is informational purpose and cannot be edited."
      : "";

  const hasLicenceErrors = Object.values(errors).some((e) => e !== "");

  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-none" />
            <Card.Body className="call-centre-create-form-card">
              <div className="new-user-info company-create-form call-centre-create-form">
                <div className="user-create-form__hero">
                  <div className="user-create-form__hero-left">
                    <span className="user-create-form__hero-icon" aria-hidden="true">
                      <FaHeadset size={22} />
                    </span>
                    <div>
                      <h5 className="user-create-form__hero-title">New Call Centre Information</h5>
                      <p className="user-create-form__hero-subtitle">
                        Configure call centre details and assign licences from your company pool.
                      </p>
                    </div>
                  </div>
                  <div className="user-create-form__required-note">
                    Fields marked with <span className="text-danger">*</span> are required
                  </div>
                </div>

                <form>
                  <div className="row g-3 call-centre-create-form__row">
                    <Form.Group className="col-12 col-lg-6 form-group mb-0">
                      <Form.Label>
                        Name <span className="text-danger">*</span>
                      </Form.Label>
                      <IconField icon={FiUser}>
                        <Form.Control
                          type="text"
                          id="name"
                          maxLength={500}
                          value={name}
                          className={`ccf-input-with-icon__control${
                            nameError ? " is-invalid" : ""
                          }`}
                          placeholder="Call centre name"
                          onChange={(e) => {
                            setName(e.target.value);
                            validateName(e.target.value);
                          }}
                          onBlur={(e) => validateName(e.target.value)}
                          required
                        />
                      </IconField>
                      {nameError && (
                        <div className="invalid-feedback d-block">{nameError}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="col-12 col-lg-6 form-group mb-0">
                      <Form.Label>
                        Domain <span className="text-danger">*</span>
                      </Form.Label>
                      <IconField icon={FiGlobe}>
                        <Form.Control
                          type="text"
                          id="domain"
                          maxLength={500}
                          value={domain}
                          className={`ccf-input-with-icon__control${
                            domainError ? " is-invalid" : ""
                          }`}
                          placeholder="https://example.com"
                          onChange={(e) => {
                            setDomain(e.target.value);
                            validateDomain(e.target.value);
                          }}
                          onBlur={(e) => validateDomain(e.target.value)}
                          required
                        />
                      </IconField>
                      {domainError && (
                        <div className="invalid-feedback d-block">{domainError}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="col-12 col-lg-6 form-group mb-0">
                      <Form.Label>
                        Country Code <span className="text-danger">*</span>
                      </Form.Label>
                      <IconField icon={FiFlag}>
                        <Form.Select
                          id="countryCode"
                          required
                          value={countryCode}
                          className="ccf-input-with-icon__control ccf-input-with-icon__select"
                          onChange={handleCountryChange}
                        >
                          <option value="">Select country</option>
                          {countryCodeList.map((val) => (
                            <option key={val.id} value={val.id}>
                              {val.name}
                            </option>
                          ))}
                        </Form.Select>
                      </IconField>
                    </Form.Group>

                    <Form.Group className="col-12 col-lg-6 form-group mb-0">
                      <Form.Label>
                        Timezone <span className="text-danger">*</span>
                      </Form.Label>
                      <IconField trailingIcon={FiClock}>
                        <Form.Select
                          id="timezone"
                          required
                          value={timezone}
                          disabled={!countryCode}
                          className="ccf-input-with-icon__control ccf-input-with-icon__select ccf-input-with-icon__control--date"
                          onChange={(e) => setTimezone(e.target.value)}
                        >
                          <option value="">Select timezone</option>
                          {filteredTimezones.map((val) => (
                            <option key={val.id} value={val.id}>
                              {val.value}
                            </option>
                          ))}
                        </Form.Select>
                      </IconField>
                    </Form.Group>

                    <Form.Group className="col-12 form-group mb-0">
                      <Form.Label>
                        Description <span className="text-danger">*</span>
                      </Form.Label>
                      <IconField icon={FiAlignLeft} textarea>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          id="description"
                          maxLength={500}
                          value={description}
                          className="ccf-input-with-icon__control ccf-input-with-icon__control--textarea"
                          placeholder="Describe this call centre"
                          onChange={(e) => setDescription(e.target.value)}
                          required
                        />
                      </IconField>
                    </Form.Group>

                    <CountryCodeDirectionPicker
                      items={countryCodeDirections}
                      selectedIds={selectedCountryCodeDirections}
                      onChange={setSelectedCountryCodeDirections}
                      label="Country Codes"
                      placeholder="Select country codes"
                      groupClassName="col-12 col-lg-6 form-group mb-0"
                      iconWrap
                    />
                  </div>

                  <DefaultCallCentreUserForm
                    name={defaultUserName}
                    setName={setDefaultUserName}
                    username={defaultUsername}
                    setUsername={setDefaultUsername}
                    email={defaultUserEmail}
                    onEmailChange={handleDefaultUserEmailChange}
                    password={defaultUserPassword}
                    setPassword={setDefaultUserPassword}
                    confirmPassword={defaultUserConfirmPassword}
                    setConfirmPassword={setDefaultUserConfirmPassword}
                    showPassword={showDefaultPassword}
                    setShowPassword={setShowDefaultPassword}
                    signupEmailOtp={signupEmailOtp}
                    setSignupEmailOtp={setSignupEmailOtp}
                    emailVerified={emailVerifiedForCreate}
                    signupEmailBusy={signupEmailBusy}
                    onSendCode={sendDefaultUserSignupEmailCode}
                    onVerifyOtp={verifyDefaultUserSignupEmailOtp}
                    roleValue={defaultUserRoleSelection}
                    setRoleValue={setDefaultUserRoleSelection}
                    roleOptions={defaultUserRoleOptions}
                    hideRoleSelect={isCompanyUserCreatingCallCentre(loginUserRole)}
                    flowType={defaultUserFlowType}
                    setFlowType={setDefaultUserFlowType}
                    aclValue={defaultUserAcl}
                    setAclValue={setDefaultUserAcl}
                    aclList={defaultUserAclList}
                  />

                  <LicenceAllocationPanel
                    showNote
                    noteMessage={licenceNote}
                    footerNote={licenceFooterNote}
                    columns={[
                      {
                        key: "agent",
                        icon: FiUsers,
                        iconModifier: "agent",
                        title: "Total Agent",
                        description: "Total number of agents",
                        value: parseInt(String(agent), 10) || 0,
                        onChange: (val) => setAgent(validateInput(String(val), "agent")),
                        onDecrement: () => stepLicence("agent", agent, setAgent, -1),
                        onIncrement: () => stepLicence("agent", agent, setAgent, 1),
                        disabledMinus: (parseInt(String(agent), 10) || 0) <= 0,
                        disabledPlus: !canIncrementLicence(
                          "agent",
                          parseInt(String(agent), 10) || 0
                        ),
                        error: errors.agent,
                      },
                      {
                        key: "live_agent",
                        icon: FiActivity,
                        iconModifier: "live",
                        title: "Live Agent",
                        description: "Agents for live calls",
                        value: parseInt(String(liveAgent), 10) || 0,
                        onChange: (val) =>
                          setLiveAgent(validateInput(String(val), "live_agent")),
                        onDecrement: () => stepLicence("live_agent", liveAgent, setLiveAgent, -1),
                        onIncrement: () => stepLicence("live_agent", liveAgent, setLiveAgent, 1),
                        disabledMinus: (parseInt(String(liveAgent), 10) || 0) <= 0,
                        disabledPlus: !canIncrementLicence(
                          "live_agent",
                          parseInt(String(liveAgent), 10) || 0
                        ),
                        error: errors.live_agent,
                      },
                      {
                        key: "channel",
                        icon: FiShare2,
                        iconModifier: "channel",
                        title: "Channels",
                        description: "Communication channels",
                        value: parseInt(String(channel), 10) || 0,
                        onChange: (val) => setChannel(validateInput(String(val), "channel")),
                        onDecrement: () => stepLicence("channel", channel, setChannel, -1),
                        onIncrement: () => stepLicence("channel", channel, setChannel, 1),
                        disabledMinus: (parseInt(String(channel), 10) || 0) <= 0,
                        disabledPlus: !canIncrementLicence(
                          "channel",
                          parseInt(String(channel), 10) || 0
                        ),
                        error: errors.channel,
                      },
                      {
                        key: "cps",
                        icon: FiPhone,
                        iconModifier: "channel",
                        title: "CPS",
                        description: "Calls per second",
                        value: parseInt(String(cps), 10) || 0,
                        onChange: (val) => setCps(validateInput(String(val), "cps")),
                        onDecrement: () => stepLicence("cps", cps, setCps, -1),
                        onIncrement: () => stepLicence("cps", cps, setCps, 1),
                        disabledMinus: (parseInt(String(cps), 10) || 0) <= 0,
                        disabledPlus: !canIncrementLicence(
                          "cps",
                          parseInt(String(cps), 10) || 0
                        ),
                        error: errors.cps,
                      },
                      {
                        key: "mobile",
                        icon: FiSmartphone,
                        iconModifier: "mobile",
                        title: "Mobile License",
                        description: "Mobile dialer licences",
                        value: parseInt(String(mobile), 10) || 0,
                        onChange: (val) => setMobile(validateInput(String(val), "mobile")),
                        onDecrement: () => stepLicence("mobile", mobile, setMobile, -1),
                        onIncrement: () => stepLicence("mobile", mobile, setMobile, 1),
                        disabledMinus: (parseInt(String(mobile), 10) || 0) <= 0,
                        disabledPlus: !canIncrementLicence(
                          "mobile",
                          parseInt(String(mobile), 10) || 0
                        ),
                        error: errors.mobile,
                      },
                    ]}
                    availableSummary={
                      loginUserRole !== USER_ROLES.SUPERADMIN ? (
                        <div className="licence-available-summary">
                          <h6 className="licence-available-summary__title">
                            Available Licence (Allocated Company)
                          </h6>
                          <div className="licence-available-summary__row">
                            <span>
                              Call Centers: {parentLicence?.available_licence?.role_ccadmin ?? 0}
                            </span>
                            <span>
                              Agent: {parentLicence?.available_licence?.role_ccagent ?? 0}
                            </span>
                            <span>
                              Live Agent: {parentLicence?.available_licence?.live_agent ?? 0}
                            </span>
                            <span>
                              Channels: {parentLicence?.available_licence?.channel ?? 0}
                            </span>
                            <span>
                              CPS: {parentLicence?.available_licence?.cps ?? 0}
                            </span>
                            <span>
                              Mobile: {parentLicence?.available_licence?.mobile ?? 0}
                            </span>
                          </div>
                        </div>
                      ) : null
                    }
                  />

                  <div className="form-actions call-centre-create-form__actions">
                    <Button
                      onClick={submitForm}
                      type="button"
                      variant="btn btn-primary"
                      disabled={
                        buttonDisable || hasLicenceErrors || !!nameError || !!domainError
                      }
                    >
                      <FaHeadset className="me-2" />
                      Create Call Centre
                      {buttonDisable ? (
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                    </Button>
                  </div>
                </form>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CallCentreCreate;
